import React from "react";
import classes from "./Payments.module.css";
import icon from "components/common/assets/9079505.png";

const PaymentSuccess = () => {
  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <p className={classes.paragraph}>Your payment was successful</p>
        <div>
          <img
            className={classes.icon}
            src={icon}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
